<template>
  <div class="container">
    <div class="title-top">
      证书信息 <!-- <span class="red">（下列仪器即将到期，请速送至运行保障处）</span> -->
    </div>
    <div class="list-container">
      <div class="device-list">
        <div class="device-amount">
          <span class="text">证书编号</span>
        </div>
        <div class="device-name">
          <span class="text">{{device.cert_code}}</span>
        </div>
      </div>
      <div class="device-list">
        <div class="device-amount">
          <span class="text">证书单位</span>
        </div>
        <div class="device-name">
          <span class="text">{{device.company_name}}</span>
        </div>
      </div>
      <div class="device-list">
        <div class="device-amount">
          <span class="text">器具名称</span>
        </div>
        <div class="device-name">
          <span class="text">{{device.device_name}}</span>
        </div>
      </div>
      <div class="device-list">
        <div class="device-amount">
          <span class="text">型号规格</span>
        </div>
        <div class="device-name">
          <span class="text">{{device.device_model}}</span>
        </div>
      </div>
      <div class="device-list">
        <div class="device-amount">
          <span class="text">出厂编号</span>
        </div>
        <div class="device-name">
          <span class="text">{{device.equip_code}}</span>
        </div>
      </div>
      <div class="device-list">
        <div class="device-amount">
          <span class="text">制造厂商</span>
        </div>
        <div class="device-name">
          <span class="text">{{device.vendor}}</span>
        </div>
      </div>
      <div class="device-list">
        <div class="device-amount">
          <span class="text">校验日期</span>
        </div>
        <div class="device-name">
          <span class="text">{{device.cert_date}}</span>
        </div>
      </div>
      <div class="device-list">
        <div class="device-amount">
          <span class="text">校验单位</span>
        </div>
        <div class="device-name">
          <span class="text">{{device.lab_name}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script type='text/ecmascript-6'>
export default {
  data () {
    return {
      type: null,
      id: null,
      code: '',
      device: {}
    }
  },
  mounted() {
    this.type = this.$route.query.type
    this.id = this.$route.query.id
    this.code = this.$route.query.code
    this.getList()
  },
  methods: {
    getList () {
      let that = this
      that.$api.getData({
        type: that.type,
        id: that.id,
        code: that.code
      }).then(res => {
        if (res.data.msg === true) {
          that.device = {...res.data.data}
        } else {
          that.$toast.center(res.data.error)
        }
      })
    }
  }
}
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
  @import '~common/stylus/common.styl'
  .container
    width:100%;
    padding:0.5rem;
    box-sizing:border-box;
    .title-top
      font-size:1rem;
      .red
        color:#EF757A;
    .list-container
      width:100%;
      margin-top:0.5rem;
      border-radius:0.5rem;
      // border: 0.05rem solid #ccc;
      border-top(#ddd);
      border-left-1px(#ddd);
      border-right(#ddd)
      .device-list
        width:100%;
        display:flex;
        justify-content: center;
        align-items: center;
        border-bottom(#ccc)
        &.list-title
          background: rgba(65, 106, 188,0.1);
          color:#666;
          font-size:0.8rem;
        .device-name
          flex:1;
          padding: 0.4rem 0.2rem;
          height:100%;
          box-sizing:border-box;
          overflow:hidden;
          .text
            display:block;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            font-size:0.6rem;
        .device-amount
          flex: 0 0 5rem;
          width:5rem
          height:100%;
          padding: 0.4rem 0.2rem;
          box-sizing:border-box;
          border-right(#ddd);
          &::after
            top:0;
          .text
            display:block;
            text-align:center;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            font-size:0.6rem;
</style>

